import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { potential_event } from '../../../elements/funciones/estructuras';

@Injectable({
  providedIn: 'root'
})
export class MatrizEventosPotService {
  private apiUrl = environment.apiOperativoDev;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookies: CookieService,
    private https: HttpClient,
  ) {  }

  getCatalogos(idInstitucion: string, catalog: string){
    const apiUrl = `${this.apiUrl}catalogues/${idInstitucion}/${catalog}`
    return this.https.get(`${apiUrl}`, {headers: this.headers})
  }
  postCatalogos(item){
    const apiUrl = `${this.apiUrl}catalogues`;
    const body = JSON.stringify(item)
    return this.https.post(`${apiUrl}`, body,{headers: this.headers})
  }
  getEventos(){
    const apiURL = this.apiUrl+'potential-events';
    return this.https.get(`${apiURL}`,{ headers: this.headers});
  }
  postEventos(rep){
    const r: potential_event = {
      institution_id: rep.institution_id,
      event_date: rep.event_date,
      area: rep.area,
      process: rep.process,
      risk_type: rep.risk_type,
      category: rep.category,
      concept: rep.concept,
      event: rep.event,
      event_detail: rep.event_detail,
      consequence: rep.consequence,
      source: rep.source,
      derived_risk: rep.derived_risk,
      loss: rep.loss,
      loss_amount: rep.loss_amount,
      transferred_loss: rep.transferred_loss,
      net_loss: rep.net_loss,
      impact: rep.impact,
      probability: rep.probability,
      mitigators: rep.mitigators,
      control_type: rep.control_type,
      periodicity: rep.periodicity,
      opportunity: rep.opportunity,
      control_effectiveness: rep.control_effectiveness,
      work_plan: rep.work_plan,
      plan_responsible: rep.plan_responsible,
      start_date: rep.start_date,
      end_date: rep.end_date,
      plan_status: rep.plan_status,
    }

    const body = JSON.stringify(r);
    const apiURL = this.apiUrl+'potential-events';
    return this.https.post(`${apiURL}`, body, {headers: this.headers})
  }
  patchEventos(rep){
    const r: potential_event = {
      institution_id: rep.institution_id,
      event_date: rep.event_date,
      area: rep.area,
      process: rep.process,
      risk_type: rep.risk_type,
      category: rep.category,
      concept: rep.concept,
      event: rep.event,
      event_detail: rep.event_detail,
      consequence: rep.consequence,
      source: rep.source,
      derived_risk: rep.derived_risk,
      loss: rep.loss,
      loss_amount: rep.loss_amount,
      transferred_loss: rep.transferred_loss,
      net_loss: rep.net_loss,
      impact: rep.impact,
      probability: rep.probability,
      mitigators: rep.mitigators,
      control_type: rep.control_type,
      periodicity: rep.periodicity,
      opportunity: rep.opportunity,
      control_effectiveness: rep.control_effectiveness,
      work_plan: rep.work_plan,
      plan_responsible: rep.plan_responsible,
      start_date: rep.start_date,
      end_date: rep.end_date,
      plan_status: rep.plan_status,
    }

    const body = JSON.stringify(r);
    const apiURL = this.apiUrl+'potential-events/'+rep.id;
    return this.https.patch(`${apiURL}`, body, {headers: this.headers})
  }
  deleteEventos(rep){
    const apiURL = this.apiUrl+'potential-events/'+rep.id;
    return this.https.delete(`${apiURL}`,{headers: this.headers});
  }
}
